import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './templates/login/login.component';
import { mainGuard } from './guards/main.guard';
import { MainAppComponent } from './templates/main-app/main-app.component';
import { RedirectComponent } from './templates/redirect/redirect.component';
import { LandingPageComponent } from './templates/landing-page/landing-page.component';
import { AuthGuard } from './guards/auth.guard';
const routes: Routes = [
  {
    path: 'home',
    component: LandingPageComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'login/:id',
    component: LoginComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'patient',
    component: MainAppComponent,
    canActivate: [mainGuard],
    loadChildren: () =>
      import('./modules/patient.module').then((m) => m.PatientModule),
  },
  {
    path: ':id',
    component: LoginComponent, // Redirect component handles redirection to '/login'
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: RedirectComponent, // Redirect empty path directly to login
    pathMatch: 'full',
  },
  {
    path: 'redirect',
    component: RedirectComponent, // Add this route for the RedirectComponent
  },
  { path: '**', component: RedirectComponent }

  // Other routes go here
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
